import { styled } from '@mui/material';

/**
 * Shared visual indicator for anything required in an assessment question -
 * the question itself (AssessmentsQuestion) or an individual answer option
 * that requires a follow-up (AssessmentsQuestionField).
 */
export const RequiredAsterisk = styled('span')(({ theme }) => ({
  color: theme.palette.red[800],
  marginLeft: theme.spacing(0.5),
}));
